import * as React from 'react';
import Button from '@telia-front/button';
import FileField from '@telia-front/filefield';
import Grid, { GridColumn } from '@telia-front/grid';
import Notice from '@telia-front/notice';
import Select from '@telia-front/select';
import Text from '@telia-front/text';
import TextAreaRows from '@telia-front/textarea-rows';
export default class TemplateMultismsSendFromFile extends React.Component {
    render() {
        return (React.createElement(Text, null,
            this.props.notice && React.createElement(Notice, Object.assign({}, this.props.notice)),
            React.createElement(Grid, null,
                React.createElement(GridColumn, { width: ['md-8'] },
                    React.createElement(TextAreaRows, Object.assign({}, this.props.contentTextArea))),
                React.createElement(GridColumn, { width: ['md-4'] },
                    React.createElement(Text, null,
                        React.createElement(Select, Object.assign({}, this.props.senderSelect)),
                        React.createElement(FileField, Object.assign({}, this.props.fileUploadField, { key: this.props.fileFieldKey }))))),
            React.createElement(Grid, { align: ['middle-xs'] },
                React.createElement(GridColumn, { width: ['xs'] },
                    React.createElement(Button, Object.assign({}, this.props.sendButton))),
                React.createElement(GridColumn, { width: ['xs'] },
                    React.createElement(Button, Object.assign({}, this.props.cancelButton))))));
    }
}
